import React, { useState, useEffect } from "react";
import axios from "axios";
import "./News.css";
import calendar from "../Photoset/calendar-days.png";
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";

function News() {
  const [staffs, setStaffs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [staffsPerPage] = useState(6); // Number of staffs per page changed to 6

  useEffect(() => {
    axios
      .get('https://school-web-server-eight.vercel.app/news')
      .then((result) => setStaffs(result.data))
      .catch((err) => console.log(err));
  }, []);


  // Pagination logic
  const indexOfLastStaff = currentPage * staffsPerPage;
  const indexOfFirstStaff = indexOfLastStaff - staffsPerPage;
  const currentStaffs = staffs.slice(indexOfFirstStaff, indexOfLastStaff);

  // Logic for displaying page numbers
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(staffs.length / staffsPerPage); i++) {
    pageNumbers.push(i);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-based month
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  //   return (
  //     <>
  //       <div className='add'>
  //         <div className='content'>
  //           <div className='header-News-1'>
  //             <div className='header'>
  //               <h1>ข่าวประชาสัมพันธ์</h1>
  //               <p></p>
  //             </div>
  //           </div>

  //           <div className='staff-list'>
  //           {currentStaffs.map((staff) => ( // Display currentStaffs instead of staffs
  //   <div className='staff-card' key={staff._id}>
  //     <a href={staff.email}>
  //       <img
  //         src={`https://http://localhost:3003/news/${staff.image}`}
  //         alt=""
  //       />
  //     </a>
  //     <div className='info'>
  //       <h3>{staff.name}</h3>
  //       <p>📅{staff.position}</p>
  //       {/* <p>{staff.email}</p> */}
  //     </div>
  //   </div>
  // ))}
  //           </div>

  //           {/* Pagination */}
  //           <ul className="pagination-ac">
  //             {/* Previous Page Button */}
  //             <li className="page-item">
  //               <button
  //                 onClick={() => setCurrentPage(currentPage - 1)} // Go to Previous Page
  //                 className="page-link"
  //                 disabled={currentPage === 1}
  //               >
  //                 <GoChevronLeft />
  //                 ก่อนหน้า
  //               </button>
  //             </li>
  //             {/* Page Numbers */}
  //             {pageNumbers.map((number) => (
  //               <li key={number} className="page-item">
  //                 <button
  //                   onClick={() => paginate(number)}
  //                   className={`page-link ${
  //                     currentPage === number ? "active" : ""
  //                   }`} // Highlight current page
  //                 >
  //                   {number}
  //                 </button>
  //               </li>
  //             ))}
  //             {/* Next Page Button */}
  //             <li className="page-item">
  //               <button
  //                 onClick={() => setCurrentPage(currentPage + 1)} // Go to Next Page
  //                 className="page-link"
  //                 disabled={currentPage === pageNumbers.length}
  //               >
  //                 ถัดไป <GoChevronRight />
  //               </button>
  //             </li>
  //           </ul>
  //         </div>
  //       </div>
  //     </>
  //   );
  return (
    <>
      <div>
        <div className="subject-container">
          <div className="ac-container">
            <div className="header-ac-1">
              <div className="header">
                <h1>ข่าวประชาสัมพันธ์สำคัญ</h1>
                <p></p>
              </div>
            </div>

            <div className="staff-news">
              {currentStaffs.map((staff) => (
                <div key={staff._id} className="staff-member-ac">
                  <a href="{staff.link}">
                    <img
                      src={`https://school-web-server-eight.vercel.app/news/${staff.image}`}
                      alt=""
                      style={{
                        width: "auto",
                        height: "100px",
                        objectFit: "fill",
                      }}
                    />
                  </a>
                  <div className="personal-details">
                    <strong>{staff.name}</strong>
                    <br />
                    <div className="text-details">
                      {formatDate(staff.position)}
                      <img
                        src={calendar}
                        alt=""
                        style={{ width: "16px", height: "16px" }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <ul className="pagination-ac">
              {/* Previous Page Button */}
              <li className="page-item">
                <button
                  onClick={() => setCurrentPage(currentPage - 1)} // Go to Previous Page
                  className="page-link"
                  disabled={currentPage === 1}
                >
                  <GoChevronLeft />
                  ก่อนหน้า
                </button>
              </li>
              {/* Page Numbers */}
              {pageNumbers.map((number) => (
                <li key={number} className="page-item">
                  <button
                    onClick={() => paginate(number)}
                    className={`page-link ${
                      currentPage === number ? "active" : ""
                    }`} // Highlight current page
                  >
                    {number}
                  </button>
                </li>
              ))}
              {/* Next Page Button */}
              <li className="page-item">
                <button
                  onClick={() => setCurrentPage(currentPage + 1)} // Go to Next Page
                  className="page-link"
                  disabled={currentPage === pageNumbers.length}
                >
                  ถัดไป <GoChevronRight />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default News;
